import { defineComponent as _defineComponent } from 'vue'
import { Icons } from '@sh/components/Utils/icons';
import OptimizerIcon from '@sh/components/Utils/OptimizerIcon.ts.vue';

interface DropdownTabContentProps {
  tabTitle: string;
  iconType: Icons;
  dataLength: number;
  showSearchBar: boolean;
  label?: string;
  titleClass?: string;
  isTabActive?: boolean;
  filterInfo?: string;
}
interface Emits {
  (e: 'clear-selected-values'): void;
  (e: 'update:search-input', data: string): void;
  (e: 'handle-on-filter-values'): void;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'DropdownTabContent.ts',
  props: {
    tabTitle: null,
    iconType: null,
    dataLength: null,
    showSearchBar: { type: Boolean },
    label: null,
    titleClass: null,
    isTabActive: { type: Boolean },
    filterInfo: null
  },
  emits: ["clear-selected-values", "update:search-input", "handle-on-filter-values"],
  setup(__props: any) {




return { __sfc: true,OptimizerIcon }
}

})